import { HoldingMethod } from './HoldingMethod';

export enum FiscalAdvantage {
  IR_PME = 'IR_PME',
  PEA = HoldingMethod.PEA,
  PEA_PME = HoldingMethod.PEA_PME,
}
